import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class ResetPasswordService {

    constructor(
        private http: HttpClient
    ) { }

    resetPassword(obj) {
        return this.http.post(environment.serverUrl + '/v1/user/reset-password', obj);
    }
}



// WEBPACK FOOTER //
// ./src/app/reset-password/reset-password.service.ts